import { gql } from "@apollo/client";
import { ContentfulComponentType } from "../types";
import { ComponentMap } from "./type-mappings";
import TextFieldsV2 from "../TextFieldsV2";
import { Component } from "../../../../__generated__/graphql";
import { FlexCol } from "ui-kit/Layout/Flex";
import Gutter from "ui-kit/Gutter";
import { ContentfulC2A } from "../ContentfulC2A";

export const ContentfulComponent: ContentfulComponentType<Component> = ({
  highlight,
  title,
  type,
  props,
  c2A,
}) => {
  const Component = ComponentMap[type ?? ""];

  if (!Component) {
    console.warn(`Unknown component type ${type}`);
    return null;
  }

  return (
    <div className="container">
      {title || highlight ? (
        <>
          <FlexCol alignItems="center" justifyContent="center">
            <Gutter size={3} />
            <TextFieldsV2 title={title} center gutterBottom={0} />
          </FlexCol>
          <Gutter size={3} />
        </>
      ) : null}
      <Component {...props} />
      {c2A && (
        <FlexCol alignItems="center" justifyContent="center">
          <Gutter size={3} />
          <ContentfulC2A {...c2A} />
        </FlexCol>
      )}
    </div>
  );
};

ContentfulComponent.fragment = gql`
  fragment Component on Component {
    highlight
    title
    type
    theme
    props
    c2A {
      ...C2A
    }
    sys {
      id
      publishedAt
    }
  }
`;
